import { LayoutSectionKey, LayoutSectionParentKey } from "@sp-crm/core";
import {
    GetLayoutContainerByKeyQuery,
    useGetLayoutContainerByKeyQuery,
} from "generated/graphql";
import { stableQueryOptions } from "util/requests";

type LayoutContainerSection =
    GetLayoutContainerByKeyQuery["getLayoutContainerByKey"]["layoutSections"][0];

export const useLayoutSection = (
    parentKey: LayoutSectionParentKey,
    sectionKey: LayoutSectionKey,
): LayoutContainerSection | null => {
    const getLayoutContainer = useGetLayoutContainerByKeyQuery(
        { key: parentKey },
        stableQueryOptions(),
    );

    return (
        getLayoutContainer.data?.getLayoutContainerByKey.layoutSections.find(
            s => s.sectionKey === sectionKey,
        ) ?? null
    );
};
